"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.initialState = void 0;

var _types = require("../types");

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(Object(source)); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  activeTab: null,
  dragX: null,
  dragY: null,
  minimized: false,
  notifications: 0,
  opened: false,
  resizeHeight: null,
  resizeWidth: null
};
exports.initialState = initialState;

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _types.APP_ACTIVE_TAB_SET:
      {
        return _objectSpread({}, state, {
          activeTab: action.payload
        });
      }

    case _types.APP_DRAG_X_SET:
      {
        return _objectSpread({}, state, {
          dragX: action.payload
        });
      }

    case _types.APP_DRAG_Y_SET:
      {
        return _objectSpread({}, state, {
          dragY: action.payload
        });
      }

    case _types.APP_MINIMIZED_SET:
      {
        return _objectSpread({}, state, {
          minimized: action.payload
        });
      }

    case _types.APP_NOTIFICATIONS_SET:
      {
        return _objectSpread({}, state, {
          notifications: action.payload
        });
      }

    case _types.APP_OPENED_SET:
      {
        return _objectSpread({}, state, {
          opened: action.payload
        });
      }

    case _types.APP_RESIZE_HEIGHT:
      {
        return _objectSpread({}, state, {
          resizeHeight: action.payload
        });
      }

    case _types.APP_RESIZE_WIDTH:
      {
        return _objectSpread({}, state, {
          resizeWidth: action.payload
        });
      }

    default:
      {
        return state;
      }
  }
};

exports.default = _default;